/** Prazo fixo desta versão. Seletor de data fica para um incremento futuro. */
export const REISSUE_DUE_DAYS = 3;

/**
 * O Laravel marca `can_retry_boleto` em cada venda. A tag Expirado e o botão
 * de regerar ficam em toda venda com a flag verdadeira.
 */
export function isExpiredBoletoSale(item) {
  return !!(item && item.can_retry_boleto === true);
}

/**
 * Link do boleto atual: boleto não pago/estornado e com URL útil.
 */
export function canOpenBoleto(item) {
  if (!item) return false;
  const method = String(item.method || '').toUpperCase();
  const status = String(item.status || '').toLowerCase();
  const url = String(item.boleto_url || '').trim();
  if (method !== 'BOLETO' || !url || url === '#') return false;
  return status !== 'paid' && status !== 'refunded' && status !== 'chargedback';
}

/**
 * URL do Abrir boleto na linha, alinhada ao facelift:
 * - enquanto elegível a regerar e ainda não regerou nesta sessão → null
 * - após sucesso, prioriza URL da resposta
 */
export function resolveOpenBoletoUrl(item, options = {}) {
  const responseUrl = options.responseUrl || null;
  const reissued = options.reissued === true;
  const canReissue = isExpiredBoletoSale(item) && !reissued;
  const detailUrl = canOpenBoleto(item) ? String(item.boleto_url).trim() : null;

  if (responseUrl) return responseUrl;
  if (reissued || !canReissue) return detailUrl;
  return null;
}

export function extractReissueErrorMessage(error) {
  const data = error && error.response && error.response.data;
  if (!data) {
    return 'Não foi possível regerar o boleto. Tente novamente.';
  }
  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  if (data.data && typeof data.data.message === 'string' && data.data.message.trim()) {
    return data.data.message.trim();
  }
  return 'Não foi possível regerar o boleto. Tente novamente.';
}

export function normalizeReissueResponse(payload) {
  const root = payload && typeof payload === 'object' ? payload : {};
  const nested = root.data && typeof root.data === 'object' ? root.data : {};

  const pick = (...values) => {
    for (const value of values) {
      if (typeof value !== 'string') continue;
      const trimmed = value.trim();
      if (!trimmed || trimmed === '#') continue;
      return trimmed;
    }
    return null;
  };

  return {
    boleto_url: pick(root.boleto_url, nested.boleto_url, nested.url, nested.link),
    boleto_barcode: pick(
      root.boleto_barcode,
      root.barcode,
      nested.boleto_barcode,
      nested.barcode
    ),
    due_date: pick(
      root.due_date,
      root.boleto_expiration_date,
      nested.due_date,
      nested.boleto_expiration_date
    ),
  };
}
